<div class="scrollable-container">
	<div class="container-padding">
		<div class="container-title title-separation" translate>datacenter.click-on-items-on-the-right</div>
		<ng-container *ngFor="let currentFilter of addedFilters">
			<copo-free-text-filter class="values-container" *ngIf="currentFilter.filterType === 'FreeText'" [filter]="currentFilter" (removeFilter)="removeFilter(currentFilter)"></copo-free-text-filter>
			<copo-date-filter class="values-container" *ngIf="currentFilter.filterType === 'Date'" [filter]="currentFilter" (removeFilter)="removeFilter(currentFilter)"></copo-date-filter>
			<copo-numeric-filter class="values-container" *ngIf="currentFilter.filterType === 'Numeric'" [filter]="currentFilter" (removeFilter)="removeFilter(currentFilter)"></copo-numeric-filter>
			<copo-product-suggestive-list-filter class="values-container" *ngIf="currentFilter.filterType === 'SuggestiveList'" [filter]="currentFilter" [additionalInput]="additionalInput" (removeFilter)="removeFilter(currentFilter)"></copo-product-suggestive-list-filter>
			<copo-product-dropdown-filter class="values-container" *ngIf="currentFilter.filterType === 'Dropdown'" [filter]="currentFilter" [additionalInput]="additionalInput" (removeFilter)="removeFilter(currentFilter)"></copo-product-dropdown-filter>
		</ng-container>
	</div>
</div>

<div class="scrollable-container">
	<div class="add-filter-sticky-container">
		<div class="add-filter-container">
			<mat-icon color="accent" svgIcon="add"></mat-icon>
			<span class="container-title" translate>datacenter.view.add-filters</span>
		</div>
		<mat-form-field class="column-search" appearance="outline" subscriptSizing="dynamic">
			<mat-icon svgIcon="search" class="column-search-icon column-search-icon-align" matPrefix></mat-icon>
			<input
					[placeholder]="'search.placeholder' | translate"
					matInput
					type="text"
					spellcheck="false"
					autocomplete="off"
					[formControl]="searchTextControl"/>
			<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
					(click)="searchTextControl.reset('');" tabindex="-1">
				<mat-icon svgIcon="md:close"></mat-icon>
			</button>
		</mat-form-field>
	</div>

	<div class="container-padding">
		<button type="button" mat-stroked-button mat-ripple class="displayed-filter-container" *ngFor="let filter of filtersToShow" (click)="addValueFilter(filter)">
			<mat-icon color="accent" class="margin-icon" svgIcon="add"></mat-icon>
			<span>{{ filter.label }}</span>
		</button>
	</div>
</div>
